import { render } from "./YearSettingsModal.vue?vue&type=template&id=62563716"
import script from "./YearSettingsModal.vue?vue&type=script&lang=js"
export * from "./YearSettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__